import { useState, useEffect, useRef } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  IconButton,
  Typography,
  Button,
  Drawer,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseAdvertisments } from "./UseAdvertisments";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import DeleteRow from "../../components/DeleteRow";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import { removeComma, toMoney } from "../../util/Utils";
import { useSnackbar } from "notistack";

export default function TariffsGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    addAdvertismentTariff,
    deleteAdvertismentTariff,
    getAdvertismentByID,
  } = UseAdvertisments();
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [open, setOpen] = useState(false);
  const addTitle = useRef(null);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [tariffRes, setTariffRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [tariffState, setTariffState] = useState({
    id: undefined,
    advertismentID: undefined,
    title: undefined,
    rowIndex: undefined,
    cost: undefined,
  });

  useEffect(() => {
    if (props.advertismentID) {
      getAdvertismentByID(props.advertismentID, (resault) => {
        setTariffRes(resault.tariffs);
      });
    }
  }, [props.advertismentID]);

  useEffect(() => {
    if (tariffRes) {
      var lastrowIndex = Math.max.apply(
        Math,
        tariffRes &&
          tariffRes.map(function (o) {
            if (o) {
              return o.rowIndex;
            } else {
              return 1;
            }
          })
      );
      setTariffState({
        ...tariffState,
        advertismentID: props.advertismentID,
        rowIndex: lastrowIndex != -Infinity ? lastrowIndex + 1 : 1,
      });
    }
  }, [tariffRes]);

  const newFunc = () => {
    setOpen(true);
    setTariffState({
      ...tariffState,
      id: undefined,
      title: undefined,
      cost: undefined,
    });
  };

  useEffect(() => {
    if (open) {
      addTitle.current.focus();
    }
  }, [open]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "rowIndex",
      headerName: "ردیف",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "cost",
      headerName: "قیمت",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="Delete">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setOpen(true);
                  setTariffState({
                    id: cellValues.row.id,
                    rowIndex: cellValues.row.rowIndex,
                    cost: cellValues.row.cost,
                    title: cellValues.row.title,
                    advertismentID: cellValues.row.advertismentID,
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      {tariffRes ? (
        <DataGrid
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={tariffRes}
          page={pageState.page - 1}
          pageSize={20}
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={tariffRes && tariffRes.length ? tariffRes.length : 1}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              rowCount: tariffRes && tariffRes.length ? tariffRes.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "ID",
                  sort: "Asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"تعرفه"}
        callback={() => {
          setProgress(true);
          deleteAdvertismentTariff(deleteState.id, () => {
            getAdvertismentByID(props.advertismentID, (resault) => {
              setTariffRes(resault.tariffs);
            });
          });
        }}
      ></DeleteRow>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setOpen(false);
          setTariffState({
            ...tariffState,
            title: "",
            cost: undefined,
          });
        }}
        sx={{
          "&  .MuiDrawer-paper": {
            height: "40%",
            width: isSmall ? "90%" : "30%",
            mx: "auto",
            borderRadius: 3,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: 4,
            m: 3,
          }}
        >
          <TextField
            color="secondary"
            id="outlined-multiline-static"
            label="عنوان"
            autoFocus
            value={tariffState.title ? tariffState.title : ""}
            inputRef={addTitle}
            onChange={(event) => {
              setTariffState({
                ...tariffState,
                title: event.target.value,
              });
            }}
            sx={{ width: "50%" }}
          />
          <TextField
            color="secondary"
            id="outlined-multiline-static"
            label="قیمت"
            value={tariffState.cost ? toMoney(tariffState.cost) : ""}
            onChange={(event) => {
              setTariffState({
                ...tariffState,
                cost: removeComma(event.target.value),
              });
            }}
            sx={{
              width: "50%",
              input: {
                textAlign: "center",
              },
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                if (!tariffState.title || !tariffState.cost) {
                  enqueueSnackbar("لطفا عنوان و قیمت را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                  });
                  return;
                }
                setProgress(true);
                addAdvertismentTariff(tariffState, () => {
                  getAdvertismentByID(props.advertismentID, (resault) => {
                    setOpen(false);
                    setTariffRes(resault.tariffs);
                    setTariffState({
                      ...tariffState,
                      title: "",
                      cost: undefined,
                    });
                  });
                });
              }
            }}
          />
          <Box sx={{ mx: "auto", mb: 3 }}>
            <Button
              variant="contained"
              sx={{ width: "100px", mr: 2 }}
              color="secondary"
              onClick={() => {
                if (!tariffState.title || !tariffState.cost) {
                  enqueueSnackbar("لطفا عنوان و قیمت را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                  });
                  return;
                }
                setProgress(true);
                addAdvertismentTariff(tariffState, () => {
                  getAdvertismentByID(props.advertismentID, (resault) => {
                    setOpen(false);
                    setTariffRes(resault.tariffs);
                    setTariffState({
                      ...tariffState,
                      title: "",
                      cost: undefined,
                    });
                  });
                });
              }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              sx={{ width: "100px" }}
              color="secondary"
              onClick={() => {
                setTariffState({
                  ...tariffState,
                  title: "",
                  cost: undefined,
                });
                setOpen(false);
              }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
